import React, { Component } from "react";
import ImagesLoaded from "react-images-loaded";
import PropTypes from "prop-types";

const hideImgDynamicStyle = {
  opacity: 0
};
const showImgDyanmicStyle = {
  opacity: 1
};

class ImageLoaderView extends Component {
  static propTypes = {
    children: PropTypes.element.isRequired
  };

  state = {
    imageLoadComplete: false
  };

  handleImageDone = element => {
    this.setState({ imageLoadComplete: true });
  };

  render() {
    const { children } = this.props;
    const { imageLoadComplete } = this.state;

    return (
      <ImagesLoaded done={this.handleImageDone}>
        <div
          style={imageLoadComplete ? showImgDyanmicStyle : hideImgDynamicStyle}
        >
          {children}
        </div>
      </ImagesLoaded>
    );
  }
}

export default ImageLoaderView;
